'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useEffect } from "react"
import { useHasMounted } from "@/lib/hooks"
import Cookies from "js-cookie"
import { REDIRECT_COOKIE } from "@/lib/constants"
import { asyncDeleteCookie } from "@/lib/helpers/cookie"

// In-flow destinations that need client state (a populated activation atom) to
// render anything but a loading spinner. The activation/transfer flows reach
// these via login-complete, which drives the redirect server-side after
// deleting the cookie. So a redirect cookie still pointing here is stale (for
// example, an abandoned SSO attempt). Honoring it would strand the user on a
// dead-end page, so we clear the cookie and skip navigation.
const DEAD_END_REDIRECT_PATHS = [
  '/passport/activate-membership/',
  '/passport/transfer/activate-membership/',
]

export function shouldSkipRedirect(redirectUrl: string) {
  try {
    const { pathname } = new URL(redirectUrl, window.location.origin)
    const normalized = pathname.endsWith('/') ? pathname : `${pathname}/`
    return DEAD_END_REDIRECT_PATHS.includes(normalized)
  } catch {
    // A malformed cookie value isn't a valid redirect target.
    return true
  }
}

function NetworkRedirect() {
  const hasMounted = useHasMounted()
  const redirectCookie = Cookies.get(REDIRECT_COOKIE)

  useEffect(() => {
    if(redirectCookie) {
      asyncDeleteCookie(REDIRECT_COOKIE).then(() => {
        // Don't strand the user on an in-flow page that needs client state.
        if(shouldSkipRedirect(redirectCookie)) return
        // we don't need to redirect if we're already there
        if(window.location.href !== redirectCookie) {
          window.location.href = redirectCookie
        }
      })
    } else {
      return
    }
  }, [redirectCookie])

  if(!hasMounted) return null

  return (<></>)
}

export default NetworkRedirect
